module.exports = __webpack_public_path__ + "static/0018-6216231fd89dc62dec659ce2dd15c287.png";